import { CosmosButton, CosmosButtonProps } from "@cosmos/web-react";
import classnames from "classnames/bind";
import Link from "next/link";
import React from "react";
import styles from "./FilterButton.module.css";

const cx = classnames.bind(styles);

export const FilterButton = ({
  children,
  selected,
  shape = "pill",
  className,
  onClick,
  disabled,
  href,
}: {
  children: React.ReactNode;
  selected?: boolean;
  shape?: "pill" | "rectangle";
  className?: string;
  onClick?: CosmosButtonProps["onClick"];
  disabled?: boolean;
  href: string;
}) => {
  return (
    <Link href={href} passHref legacyBehavior>
      <CosmosButton
        onClick={onClick}
        className={cx("button", className)}
        size="small"
        kind="secondary"
        appearance="dark"
        shape={shape}
        hovered={selected}
        disabled={disabled}
      >
        {children}
      </CosmosButton>
    </Link>
  );
};
